/**
 * Regras de cod_etapa dos modais de adicionar funcionário e alterar gestor, extraídas sem mudança de
 * AddEquipe.getValidValues e ChangeGestor.isSwitchable.
 */

/** cod_etapa que o líder pode buscar para incluir na equipe (`find/gestores`). */
export function codigosParaAdicionar(codEtapa: number | undefined): number[] {
  switch (codEtapa) {
    case 1:
      return [2, 0];
    case 2:
      return [0];
    case 3:
      return [2, 0];
    case 4:
      return [3, 2, 1, 0];
    case 5:
      return [4, 3, 2, 1, 0];
    default:
      return [];
  }
}

/** Se o líder pode indicar o novo gestor escolhido para um liderado. */
export function podeTrocarGestor(codEtapaDoLider: number | undefined, codEtapaDoAlvo: unknown): boolean {
  if (typeof codEtapaDoAlvo !== 'number' || typeof codEtapaDoLider !== 'number') return false;

  if (codEtapaDoLider >= 1 && codEtapaDoLider <= 3) return codEtapaDoAlvo >= 1 && codEtapaDoAlvo <= 3;
  if (codEtapaDoLider === 4) return [1, 3, 4].includes(codEtapaDoAlvo);
  if (codEtapaDoLider === 5) return [4, 5].includes(codEtapaDoAlvo);
  return false;
}
